<template lang="pug">
.wrapper
  md-layout(:md-gutter='16')
    md-layout(md-flex='33', :md-gutter='16')
      md-layout(md-flex='100', md-flex-small='100')
        // Search
        md-input-container
          label Keywords
          md-input(type='text', v-model='search.name', @keyup.enter.native="goSearch")

    md-layout(md-flex='33', :md-gutter='16')
      md-layout(md-flex='50', md-flex-small='100')
        // Language
        md-input-container(v-if="languages.length")
          label(for='language') Language
          md-select#language(v-model='search.language')
            md-option(value='') Any
            md-option(v-for='language of languages', :value='language.code', :key="language.code") {{ language.name }}
      md-layout(md-flex='50', md-flex-small='100')
        // Sort
        md-input-container(v-if="sort.length")
          label(for='sort') Sort by
          md-select#sort(v-model='sort', @selected='updateSort')
            md-option(value='newest') Newest
            md-option(value='alpha-asc') A-Z
            md-option(value='alpha-desc') Z-A
    md-layout(md-flex='33', :md-gutter='16')
      md-layout(md-flex='50', md-flex-small='100')
        // Genres
        md-input-container(v-if="genres.length")
          label(for='genre') Genre
          md-select#genre(v-model='search.genre')
            md-option(value='') Any
            md-option(v-for='genre of genres', :value='genre' :key="genre") {{ genre }}

      md-layout.buttons(md-flex='50', md-flex-small='100', md-align='center')
        //Erase
        md-button.md-icon-button.md-raised(v-if="search.name || search.network || search.language || search.genre", @click='cleanSearch', md-theme='blue')
          md-icon(md-iconset="fa fa-trash-alt")
        // Search
        md-button.md-icon-button.md-raised(@click='goSearch', md-theme='blue')
          md-icon(md-iconset="fa fa-search")
</template>

<script>
  import ISO_LANGS from '../../assets/data/languages';
  import mediaItemService from '../../services/mediaItemService';

  export default {
    props: {
      search: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        loadingNetworks: false,
        languages: [],
        genres: [],
        networks: [],
        sort: ''
      };
    },
    methods: {
      getLanguages() {
        const params = { filter: 'language' };
        mediaItemService.getFilterOptions(params)
          .then((response) => {
            this.languages = ISO_LANGS;
          });
      },
      getGenres() {
        const params = { filter: 'categories' };
        mediaItemService.getFilterOptions(params)
          .then((response) => {
            this.genres = response.data.filterOptions;
          });
      },
      updateSort(sort) {
        if (sort) {
          switch (sort) {
            case 'newest': {
              this.search.sort = { sortBy: 'lastUpdated', sortOrder: 'desc' };
              break;
            }
            case 'alpha-asc': {
              this.search.sort = { sortBy: 'name', sortOrder: 'asc' };
              break;
            }
            default: {
              this.search.sort = { sortBy: 'name', sortOrder: 'desc' };
            }
          }
        }
      },
      goSearch() {
        this.$emit('goSearch');
      },
      cleanSearch(){
        this.$emit('cleanSearch')
      }

    },
    mounted() {
      this.getGenres();
      this.getLanguages();
      const { sortBy, sortOrder } = this.search.sort;
      if (sortBy === 'name' && sortOrder === 'asc') {
        this.sort = 'alpha-asc';
      } else if (sortBy === 'name' && sortOrder === 'desc') {
        this.sort = 'alpha-desc';
      } else {
        this.sort = 'newest';
      }
    }
  };
</script>

<style lang="scss" scoped>
.wrapper{
  padding: 5px;
}
  .select-loader {
    margin-top: 25px;
  }
  .search-btn {
    margin: 0 6px;
    height: 40px;
    border-radius: 4px;
    padding: 0 10px;
  }
  @media(max-width: 1250px){
    .search-btn{
      transition: all .3s ease-in;
      font-size: small;
      padding: 0 5px;
    }
  }
  .md-input-container{
    margin: 0;
  }

  .buttons{
    margin-top: 10px;
  }
  .btn{
    margin-top: 10px !important;
    align-items: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/MediaItemFilters.vue